import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session.service';
import { finalize } from 'rxjs/operators';
@Component({
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive
  ],

  template:`
  <div class="login-card">
    <div class="spinner-container" *ngIf="isLoadingPageContent">
      <span class="spinner"></span>
    </div>
    <div *ngIf="showLoginSection">
      <div class="section-title">
        Login
      </div>
      <p class="pin-text">
        Enter your 4-digit PIN.
      </p>
      <div class="pin-warning-text"  *ngIf="pinValidationMessage">
        {{pinValidationMessage}}
      </div>
      <!-- PIN INPUT -->
      <div class="pin-wrapper">
        <input
          #pinInput
          class="hidden-pin-input"
          type="password"
          inputmode="numeric"
          maxlength="4"
          autocomplete="one-time-code"
          [(ngModel)]="loginPin"
          (keydown)="allowOnlyNumbers($event)"
          (ngModelChange)="onPinChange($event)">

        <div class="pin-wrapper">
          <!-- Hidden input -->
        <input
          #pinInput
          class="hidden-pin-input"
          type="password"
          inputmode="numeric"
          maxlength="4"
          autocomplete="one-time-code"
          [(ngModel)]="loginPin"
          (keydown)="allowOnlyNumbers($event)"
          (ngModelChange)="onPinChange($event)">

          <!-- Click anywhere to focus -->
          <div class="pin-display" (click)="pinInput.focus()">
            <div class="pin-circle"
                [class.filled]="loginPin.length > 0"
                [class.active]="loginPin.length === 0">
              {{ loginPin.length > 0 ? '•' : '' }}
            </div>

            <div class="pin-circle"
                [class.filled]="loginPin.length > 1"
                [class.active]="loginPin.length === 1">
              {{ loginPin.length > 1 ? '•' : '' }}
            </div>

            <div class="pin-circle"
                [class.filled]="loginPin.length > 2"
                [class.active]="loginPin.length === 2">
              {{ loginPin.length > 2 ? '•' : '' }}
            </div>

            <div class="pin-circle"
                [class.filled]="loginPin.length > 3"
                [class.active]="loginPin.length === 3">
              {{ loginPin.length > 3 ? '•' : '' }}
            </div>
          </div>
        </div>
      </div>

      <!-- BUTTONS -->
      <div class="btns">
        <button class="set-authorization-btn"
          (click)="login()"
          [disabled]="isLoading || loginPin.length !== 4">
          <span *ngIf="!isLoading">Login</span>
          <span *ngIf="isLoading" class="spinner"></span>
        </button>
      </div>
      <a class="forgot-pin" (click)="forgotPin()">
          I forgot my PIN
        </a>
    </div>
  </div>

  <div class="overlay" *ngIf="showErrorPopup">
    <div class="alert-modal">
      <p class="pin-text">
          {{ errorMessage }}
      </p>
      <div class="btns">
        <button
          class="primary"
          (click)="closeErrorPopup()">
          Close
        </button>
      </div>
    </div>
  </div>

  <div class="overlay" *ngIf="showRetryPopUp">
    <div class="alert-modal">
      <p class="pin-text">
          {{ errorMessage }}
      </p>
    </div>
  </div>
  `
})
export class LoginPage{
 userId = '';
 loginKey = ''
  whatsAppUrl = environment.whatsapp_url;
  isLoading = false;
  showLoginSection = false;
  isLoadingPageContent = true;
  constructor(private router: Router, 
              private route: ActivatedRoute, 
              private authService: AuthService,
              private sessionService: SessionService) {}
  ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('userId') ?? '';
    if (!this.userId) {
      this.errorMessage = 'Invalid link';
      this.showErrorPopup = true;
      return;
    }
    this.getLoginKey();
  }
  getLoginKey() {
    this.authService
    .getLoginKey(this.userId)
    .subscribe({
        next: response => {
          this.loginKey = response.loginkey
          if(response.loginAttempts)
            this.pinValidationMessage = response.loginAttempts;

          this.isLoadingPageContent = false;
          this.showLoginSection = true;
        },
        error: err => {
          this.showLoginSection = false;
          if (err.status === 403) {
            window.location.href = this.whatsAppUrl;
          }
          else if (err.status === 423){
            this.router.navigateByUrl(
              '/unlockaccount',
              { replaceUrl: true }
            );
            return;
          }
          else if (err.status === 421){
            this.router.navigateByUrl(
              '/setsecurityquestions/' + this.userId,
              { replaceUrl: true }
            );
            return;
          }
          else{
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
          }
        }
      },
    );
  }
  // =====================================================
  // ERROR
  // =====================================================
    errorMessage = '';
    showErrorPopup = false;
    showRetryPopUp = false;
    closeErrorPopup() {
      window.location.href = this.whatsAppUrl;
    }
  // =====================================================
  // AUTHORIZZATION
  // =====================================================
  pinValidationMessage = ''
  loginPin = '';
  onPinChange(value: string): void {
    this.loginPin = value.replace(/\D/g, '').slice(0, 4);
  }
  login(){
    this.isLoading = true;
    this.authService
    .postLogin(this.loginKey,this.userId, this.loginPin)
     .pipe(
          finalize(() => this.isLoading = false)
        )
    .subscribe({
        next: response => {
          this.sessionService.setSession(response.sessionToken);
          this.sessionService.setUserId(this.userId);
          this.sessionService.setWalletBlance(response.walletBalance);
          this.router.navigate(['/']);
        },
        error: err => {
          this.showLoginSection = false;
          if (err.status === 423) {
            window.location.href = this.whatsAppUrl;
          }
          else if (err.status === 401) {
            this.showLoginSection = true;
            this.pinValidationMessage =  err.error?.message ?? 'Unauthorized'
          }
          else if (err.status === 404) {
            this.errorMessage = 'Login failed, please reload page and try again.';
            this.showRetryPopUp = true;
            setTimeout(()=> this.showRetryPopUp = false, 3000);
          }
          else{
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
          }
        }
      },
    );
  }
  forgotPin(){
    this.router.navigateByUrl(
      '/forgotpin/' + this.userId,
      { replaceUrl: true }
    );
  }
  // =====================================================
  // COMMON
  // =====================================================
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End'
    ];
    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }
    // Block everything except digits
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
}